import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const refreshTokenRepresentativeCommand = (
  repository: IRepresentativeRepository,
  refreshToken: string,
) => {
  return repository.refreshToken(refreshToken)
}
